import React from 'react';
import { Div, Typography, Circle } from '@icecreamsocial/components';
import { GiftCardIcon } from '../SupportedIcons';
import { useAtom } from 'jotai';
import {
	behaviorAtom,
	campaignAtom,
	variableMapAtom,
} from '../../../shared/atoms';
import { replaceVariables } from '../../../utils';
import { flags } from '../../../utils/featureFlags';

/**
 * @featureflags
 */

const ENABLE_EXPERIMENTAL_INCENTIVE_FLOW = flags.isActive(
	flags.names.ENABLE_EXPERIMENTAL_INCENTIVE_FLOW
);

/**
 * @todo probably move this to container components
 */

export const Offer = () => {
	const [{ campaign }] = useAtom(campaignAtom);
	const [behavior] = useAtom(behaviorAtom);
	const [varMap] = useAtom(variableMapAtom);

	const SHOW_INCENTIVE =
		ENABLE_EXPERIMENTAL_INCENTIVE_FLOW && behavior?.type === 'incentive';
	const heading = SHOW_INCENTIVE
		? 'Claim your exclusive offer!'
		: replaceVariables(campaign?.offerHeading, varMap);
	const description = SHOW_INCENTIVE
		? campaign?.discountCodeDesc
		: replaceVariables(campaign?.offerInstructions, varMap);

	return (
		<>
			<Div textAlign='center'>
				<Typography.H1>{heading}</Typography.H1>
			</Div>

			<Div
				position='relative'
				borderRadius='default'
				padding={['md', 'lg']}
				marginTop='xlg'
				marginBottom='md'
				backgroundColor='ambient'
			>
				<Typography.P>{description}</Typography.P>
			</Div>
		</>
	);
};
